import styled from 'styled-components';
import { Tooltip } from 'antd';

const StyledTooltip = styled(Tooltip)`
    margin: auto;
`;

export default StyledTooltip;
